import React from "react";
import { Card, CardGrid, Container, Header } from "./Elements";
import { motion } from 'framer-motion';

import imagea1 from './image/a1.jpg'
import imagea2 from './image/a2.jpg'
import image1 from './image/1.jpg'
import image2 from './image/2.jpg'
import image3 from './image/3.jpg'
import image4 from './image/4.jpg'
import image5 from './image/5.jpg'
import image6 from './image/6.jpg'
import image7 from './image/7.jpg'
import image8 from './image/8.jpg'
import image9 from './image/9.jpg'
import image10 from './image/10.jpg'
import image11 from './image/11.jpg'
import image12 from './image/12.jpg'
import image13 from './image/13.jpg'
import image14 from './image/14.jpg'
import logo from './image/logo.png'
import phone from './image/phone.png'

const color = {
  primary: '#333'
}
const App = () => {

  return (
    <>
      <Header style={{ background: color.primary }}>
      <img style={{ height: 50 }} src={logo} />
      <img style={{ height: 30, position: "absolute", right: 130, top: 50 }} src={phone} />
      <p style={{ position: "absolute", right: 10, top: 10 }}>For Reservation:     </p>
      <p style={{ position: "absolute", right: 10, top: 40 }}>096 906 6006</p>
      <p style={{ position: "absolute", right: 10, top: 60 }}> 095 99 6000</p>
      </Header>
      <motion.div
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
          y: -70,
        }}
        transition={{
          duration: 1
        }}
      >
        <Container>
          <CardGrid>
          <Card >
              <img src={imagea1} alt='menu' />
            </Card>
            <Card >
              <img src={imagea2} alt='menu' />
            </Card>
            <Card >
              <img src={image1} alt='menu' />
            </Card>
            <Card >
              <img src={image2} alt='menu' />
            </Card>
            <Card >
              <img src={image3} alt='menu' />
            </Card>
            <Card >
              <img src={image4} alt='menu' />
            </Card>
            <Card >
              <img src={image5} alt='menu' />
            </Card>
            <Card >
              <img src={image6} alt='menu' />
            </Card>
            <Card >
              <img src={image7} alt='menu' />
            </Card>
            <Card >
              <img src={image8} alt='menu' />
            </Card>
            <Card >
              <img src={image9} alt='menu' />
            </Card>
            <Card >
              <img src={image10} alt='menu' />
            </Card>
            <Card >
              <img src={image11} alt='menu' />
            </Card>
            <Card >
              <img src={image12} alt='menu' />
            </Card>
            <Card >
              <img src={image13} alt='menu' />
            </Card>
            <Card >
              <img src={image14} alt='menu' />
            </Card>
          </CardGrid>
        </Container>
      </motion.div>
    </>
  );
}

export default App;
